import { createGlobalStyle } from "styled-components";

import resetCSS from "./reset";

export default createGlobalStyle`
${resetCSS}
body {
    font-weight: 400;
    width: 100%;
    position: relative;
}
a {
    text-decoration: none;
}

html,
body,
#root {
    height: 100%;
}
`;
